// removed by extract-text-webpack-plugin
module.exports = {"arrow":"jQdvWxZd","icon":"_19MIyDoe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/Arrow/Arrow.pcss
// module id = 779
// module chunks = 0